import React, { useEffect, useState } from "react";

import {
	Button,
	CloseButton,
	HStack,
	IconButton,
	Modal,
	ModalBody,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
} from "@chakra-ui/react";

import { Mapbox } from "common/components/AssetModal/Mapbox";

interface MapModalProps {
	isOpen: boolean;
	onClose: () => void;
	setCoordinates?: (coordinates: [number, number] | undefined) => void;
	initialValue?: [number, number];
}

export const EditLocationModal: React.FC<MapModalProps> = (props) => {
	const { isOpen, onClose, setCoordinates, initialValue } = props;

	const [temporalCoordinates, setTemporalCoordinates] = useState<[number, number] | undefined>(initialValue);
	const [fullscreen, setFullscreen] = useState(false);

	useEffect(() => {
		if (isOpen) {
			setTemporalCoordinates(initialValue);
			setFullscreen(false);
		}
	}, [isOpen]);

	const handleCancel = () => {
		setTemporalCoordinates(initialValue);
		onClose();
	};

	return (
		<Modal isOpen={isOpen} onClose={handleCancel} size={fullscreen ? "full" : "xl"}>
			<ModalOverlay />
			<ModalContent
				marginTop={fullscreen ? 0 : "6rem"}
				display="flex"
				flexDirection="column"
				height={fullscreen ? "100vh" : undefined}
			>
				<ModalHeader>Selecciona dirección</ModalHeader>
				<HStack position="absolute" top="2" right="3" spacing={1}>
					<IconButton
						aria-label={fullscreen ? "Reducir" : "Ampliar"}
						variant="ghost"
						size="md"
						onClick={() => setFullscreen((f) => !f)}
						icon={
							fullscreen ? (
								<svg width="16" height="16" viewBox="0 0 24 24">
									<path fill="currentColor" d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z" />
								</svg>
							) : (
								<svg width="16" height="16" viewBox="0 0 24 24">
									<path fill="currentColor" d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z" />
								</svg>
							)
						}
					/>
					<CloseButton size="md" onClick={handleCancel} />
				</HStack>
				<ModalBody flex="1" minH="0" overflow="hidden" p={2}>
					<Mapbox
						setCoordinates={(coordinates) => setTemporalCoordinates(coordinates)}
						value={temporalCoordinates}
						mapHeight={fullscreen ? "100%" : "30rem"}
						hideExpand
					/>
				</ModalBody>

				<ModalFooter>
					<Button height="2rem" mr={3} onClick={handleCancel} variant="ghost">
						Cancelar
					</Button>
					<Button
						height="2rem"
						mr={3}
						variant="ghost"
						onClick={() => {
							if (setCoordinates) {
								setTemporalCoordinates(undefined);
								setCoordinates(undefined);
							}
						}}
					>
						Borrar
					</Button>
					<Button
						height="2rem"
						onClick={() => {
							if (setCoordinates && temporalCoordinates) {
								setCoordinates(temporalCoordinates);
							}
							onClose();
						}}
					>
						Guardar
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};
